module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("52XE4"))).then(() => parcelRequire('d0iPb'));